<template>
  <div v-if="shouldShowAnyDevControl" class="flex items-center gap-4 text-xs">
    <!-- Dev Mode Toggle -->
    <button
      v-if="shouldShowDevModeToggle"
      :class="devModeButtonClasses"
      @click="toggleDevMode"
    >
      Dev Mode: {{ isDevModeEnabled ? 'ON' : 'OFF' }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useDevModeStore } from '@/stores/devMode';

// Dev mode store
const devModeStore = useDevModeStore();
const { isDevModeEnabled, shouldShowDevModeToggle } = storeToRefs(devModeStore);

// Actions
const { toggleDevMode } = devModeStore;

// Show dev dashboard if any control should be visible
const shouldShowAnyDevControl = computed(() => shouldShowDevModeToggle.value);

// Computed styles
const devModeButtonClasses = computed(() => [
  'rounded px-2 py-1 text-xs font-medium transition-colors',
  isDevModeEnabled.value
    ? 'bg-green-500 text-white hover:bg-green-600'
    : 'bg-gray-500 text-white hover:bg-gray-600',
]);
</script>
